export default __webpack_public_path__ + "static/media/cs-glossary.16d81953.png";